export const module = {
  info: {
    name: 'jikatel-ivr-extension',
    caption: 'Jikatel IVR Extension'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel IVR Extension',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-ivr-extension->panel',
    children: [
      {
        caption: 'Create IVR Extension',
        icon: 'el-icon-plus',
        routeName: 'module->jikatel-ivr-extension->create'
      },
      {
        caption: 'List IVR Extensions',
        icon: 'el-icon-more-outline',
        routeName: 'module->jikatel-ivr-extension->list'
      }
    ]
  }
}

export default module
